import * as Yup from "yup"

export class AffiliatesSearchForm
{
	city: string|null = null
	category: string|null = "01H95XD3XJD86AH3DW7AF6H9QY"
}

const AffiliatesSearchValidation = {
	city: Yup.string().required(),
	category: Yup.string().required(),
}

export default Yup.object()
	.shape(
		AffiliatesSearchValidation,
	)
	.required()
